import { render, staticRenderFns } from "./Kraken.vue?vue&type=template&id=b6a07864&scoped=true&"
import script from "./Kraken.vue?vue&type=script&lang=js&"
export * from "./Kraken.vue?vue&type=script&lang=js&"
import style0 from "./Kraken.vue?vue&type=style&index=0&id=b6a07864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a07864",
  null
  
)

export default component.exports